import api from "./axiosInstance";
import { Filme } from "../models/Filme";
import { PaginatedResponse } from "../models/DTOs/PaginatedResponse";
import { GeneroEnum } from "../models/enums/GeneroEnum";

const getAuthHeader = () => {
  const token = localStorage.getItem("token"); // supondo que você armazene assim
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listMovies = async (search?: string, genero?: GeneroEnum): Promise<PaginatedResponse<Filme>> => {
  const res = await api.get<PaginatedResponse<Filme>>(
    "/filme/list-paginated",
    {
      params: {
        page: 1,
        pageSize: 999,
        genero: genero,
        search: search,
      },
    }
  );

  return res.data; // 👈 retorna o objeto inteiro
};

export const createMovie = async (
  nome: string,
  genero: GeneroEnum,
  nota: number
): Promise<Filme> => {
  const res = await api.post(
    `${process.env.REACT_APP_API_URL}/filme/create`,
    { nome, genero, nota },
    { headers: { "Content-Type": "application/json", ...getAuthHeader() } }
  );
  return res.data.movie;
};

export const updateMovie = async (
  id: string,
  nome?: string,
  genero?: number,
  nota?: number
): Promise<Filme> => {
  const res = await api.put(
    `${process.env.REACT_APP_API_URL}/filme/update`,
    { id, nome, genero, nota },
    { headers: { "Content-Type": "application/json", ...getAuthHeader() } }
  );
  return res.data.movie;
};

export const deleteMovie = async (id: string): Promise<{ message: string }> => {
  const res = await api.delete(
    `${process.env.REACT_APP_API_URL}/filme/delete?id=${id}`,
    { headers: getAuthHeader() }
  );
  return res.data;
};
